import { Button, Collapse } from 'antd';
import recruitmentAiApi, { AICandidateInterviewQuestions } from 'api/recruitmentAiApi';
import RecruitmentAiPromptModal from 'features/recruitment/components/RecruitmentAiPromptModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const { Panel } = Collapse;

const QuestionCandidate = ({ data: dataParent, onSaveGeneratedQuestions }: any) => {
  const { t } = useTranslation(['recruitment', 'action']);
  const [visibleAiModal, setVisibleAiModal] = useState(false);
  const [aiPrompt, setAiPrompt] = useState('');
  const [generatedQuestions, setGeneratedQuestions] =
    useState<AICandidateInterviewQuestions | null>(null);

  return (
    <>
      <Actions>
        <AiButton onClick={() => setVisibleAiModal(true)}>
          {t('recruitment:ai_generate_candidate_questions')}
        </AiButton>
      </Actions>
      {generatedQuestions && (
        <div style={{ marginBottom: 20 }}>
          <Collapse>
            <Panel header={generatedQuestions.name} key="ai-generated">
              {generatedQuestions.questions.map((question, index) => (
                <div key={question} style={{ display: 'flex' }}>
                  <p>{index + 1}.</p>
                  <p>&nbsp;{question}</p>
                </div>
              ))}
              <Actions>
                <Button onClick={() => onSaveGeneratedQuestions(generatedQuestions)}>
                  {t('recruitment:ai_save_to_notes')}
                </Button>
              </Actions>
            </Panel>
          </Collapse>
        </div>
      )}
      {dataParent?.questions?.map((item: any, key: any) => {
        return (
          <div style={{ position: 'relative' }}>
            <Collapse style={{ marginBottom: 20, borderRadius: 5 }}>
              <Panel header={item?.name} key={key} style={{ fontWeight: '700' }}>
                {item?.questions?.map((item: any, key: any) => {
                  return (
                    <div style={{ display: 'flex', fontWeight: '400' }}>
                      <p>{key + 1}.</p>
                      <p>&nbsp;{item}</p>
                    </div>
                  );
                })}
              </Panel>
            </Collapse>
          </div>
        );
      })}
      <RecruitmentAiPromptModal<AICandidateInterviewQuestions>
        visible={visibleAiModal}
        title={t('recruitment:ai_candidate_questions_title')}
        description={t('recruitment:ai_candidate_questions_description')}
        promptLabel={t('recruitment:ai_candidate_questions_prompt_label')}
        placeholder={t('recruitment:ai_candidate_questions_placeholder')}
        initialPrompt={aiPrompt}
        generateLabel={t('recruitment:ai_generate')}
        generatingLabel={t('recruitment:ai_generating')}
        cancelLabel={t('action:cancel')}
        reviewNote={t('recruitment:ai_review_before_save')}
        onCancel={() => setVisibleAiModal(false)}
        onGenerate={(prompt, outputLanguage) =>
          recruitmentAiApi.generateCandidateInterviewQuestions({
            prompt,
            context: {
              candidateId: dataParent?.id,
              cvUrl: dataParent?.linkProfile,
              candidate: {
                candidateName: dataParent?.candidateName,
                currentJob: dataParent?.currentJob,
                yearExperience: dataParent?.yearExperience,
                skills: dataParent?.skills,
                certifications: dataParent?.certifications,
              },
              jobs: dataParent?.jobs,
              existingQuestions: dataParent?.questions,
            },
            options: { language: outputLanguage },
          })
        }
        onGenerated={(result, prompt) => {
          setGeneratedQuestions(result);
          setAiPrompt(prompt);
          setVisibleAiModal(false);
        }}
      />
    </>
  );
};

export default QuestionCandidate;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 16px;
`;

const AiButton = styled(Button)`
  color: var(--cl_primary500);
  border-color: var(--cl_primary500);

  &:hover,
  &:focus {
    color: var(--cl_primary500);
    border-color: var(--cl_primary500);
  }
`;
